import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Typography,
    Box
} from '@mui/material';
import { PutProductDistributorFulfillmentType } from '../hooks/useFetchProductSettingsDistributorOverrides';
import { SkuFulfillmentMethod } from '../../../Enums/SkuFulfillmentMethod';

const toYyyyMmDdInput = (apiDate) => {
    if (!apiDate) return '';
    const s = String(apiDate);
    const m = s.match(/^(\d{4}-\d{2}-\d{2})/);
    return m ? m[1] : s.slice(0, 10);
};

const ReplenishableInMarketDateDialog = ({ open, onClose, onSave, currentDistributor, sku, isChanging = false }) => {
    const [dateValue, setDateValue] = useState('');

    useEffect(() => {
        if (!open) return;
        if (isChanging)
            setDateValue(toYyyyMmDdInput(currentDistributor.inMarketDateOverride));
        else
            setDateValue('');
    }, [open, isChanging, currentDistributor.inMarketDateOverride]);

    const handleSave = async () => {
        const apiDate = dateValue.trim() === '' ? null : dateValue.trim();

        try {
            const distributorRow = {
                skuFulfillmentType: { id: SkuFulfillmentMethod.REPLENISHABLE }
            };

            await PutProductDistributorFulfillmentType(
                { sku },
                { id: currentDistributor.distributorId, ...distributorRow },
                null,
                { setInMarketDate: true, inMarketDate: apiDate }
            );

            onSave(apiDate);
            onClose();
        } catch (error) {
            console.error('Error saving in-market date:', error);
            alert('Error saving in-market date');
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>{isChanging ? 'Edit In-Market Date' : 'Replenishable — In-Market Date'}</DialogTitle>
            <DialogContent>
                <Box sx={{ mb: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                        {isChanging
                            ? 'Update or clear the in-market date for this replenishable product. Clearing uses the SKU default.'
                            : 'Optionally set an in-market date for replenishable fulfillment. Leave empty to use the SKU default.'}
                    </Typography>
                </Box>
                <TextField
                    label="In-market date"
                    type="date"
                    value={dateValue}
                    onChange={(e) => setDateValue(e.target.value)}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={handleSave} variant="contained">
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
};

ReplenishableInMarketDateDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    currentDistributor: PropTypes.object.isRequired,
    sku: PropTypes.string.isRequired,
    isChanging: PropTypes.bool
};

export default ReplenishableInMarketDateDialog;
